import { render, staticRenderFns } from "./ScoutingReportBrief.vue?vue&type=template&id=ff0756f4&scoped=true&"
import script from "./ScoutingReportBrief.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportBrief.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingReportBrief.vue?vue&type=style&index=0&id=ff0756f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0756f4",
  null
  
)

export default component.exports